import React, { useEffect, useMemo, useRef, useState } from "react";
import "./patient-search.scss";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";
import {
  getPatients,
  resetAllPatients,
} from "../../../store/slices/patientSlice";
import { dateFormat } from "../../../utils/common-funtions/common";

const PatientSearch = ({
  setSelectedTabOption,
  setIsNewUser,
  setSinglePatientInfo,
  singlePatientInfo,
  selectedTabOption,
  height = 90,
  buttonName,
  isNewUser,
}) => {
  const dispatch = useDispatch();
  let { isLoading, allPatients, noPatientFound } = useSelector(
    (state) => state.patient
  );
  const { user } = useSelector((state) => state.auth);
  const [key, setKey] = useState("name")
  const [inputValue, setInputValue] = useState()
  const ref = useRef()
  const showPatientFun = (value) => {

    if (value?.length >= 1)
      dispatch(getPatients({ search: value?.trim(), key: key, doctorId: user?.user?._id }));
    else if (value?.length < 1) {
      dispatch(resetAllPatients());
      setSinglePatientInfo({});
      setIsNewUser(true);
    }
  };

  const setKeyFun = (value) => {
    setInputValue("")
    setKey(value)
  }

  useMemo(() => {
    if (isNewUser) {
      if (document.getElementById("patient-search"))
        document.getElementById("patient-search").value = "";
      dispatch(resetAllPatients());
    }
  }, [isNewUser]);

  const handleKeyDown = (event) => {
    if ((event.key == "Enter" && ref?.current.className == "patient-search-section")) {
      event.preventDefault();
      showPatientFun(inputValue)
    }
  }
  useEffect(() => {
    if (inputValue)
      document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [inputValue]);

  return (
    <div className="patient-search-section" style={{ height: `${height}vh` }} ref={ref}>
      <div className="d-flex p-1 pl-1">
        <small className="px-1 " style={{ width: "40%", fontWeight: "600" }}>Search patient by:</small>
        <select
          style={{ width: "60%" }}
          onChange={(e) => {
            setKeyFun(e.target.value);
          }}
        >
          <option value={'name'}>Name </option>
          <option value={'patientId'}>Patient Id </option>
          <option value={'phone'}> Phone</option>
          <option value={'dob'}>Dob </option>
        </select>{" "}
      </div>
      <div className="mx-1 d-flex" >
        <input
          onChange={(e) => setInputValue(e.target.value)}
          placeholder={`Search existing patient by ${key}`}
          type={`${key == "dob" ? 'date' : "text"}`}
          id="patient-search"
          autoComplete="off"
          value={inputValue || ""}
          className="mx-auto d-block search-input mx-2"
        ></input>
        <button onClick={() => { showPatientFun(inputValue) }} className="btn button">Search <small>(press enter or click here)</small></button>
      </div>
      <div className="search-result-section mx-auto">
        <table
          id="example2"
          className="table table-hover table-sm table-responsive{-sm|-md|-lg|-xl}"
        >
          <thead>
            {/* table heading */}
            <tr>
              <th>ID</th>
              <th>NAME</th>
              <th>PHONE</th>
              <th>DOB</th>
              {/* <th>GENDER</th> */}
            </tr>
          </thead>

          <tbody>
            {allPatients?.length >= 0 && !isLoading &&
              allPatients?.map((patient, index) => {
                return (
                  <tr
                    key={index}
                    className={`${patient?._id === singlePatientInfo?._id
                      ? "active-patient"
                      : ""
                      }`}
                    onClick={() => {
                      setIsNewUser(false);
                      setSinglePatientInfo(patient);
                    }}
                  >
                    <td className="pt-1" style={{ fontWeight: "700" }}>{patient?.patientId}</td>
                    <td className="pt-1">{patient?.name}</td>
                    <td className="pt-1">{patient?.phone}</td>
                    <td className="pt-1">{dateFormat(patient?.dob?.slice(0, 10))}</td>
                    {/* <td className="">{patient?.gender}</td> */}
                  </tr>
                );
              })}

            {allPatients?.length === 0 && noPatientFound && !isLoading && (
              <p className="no-patient-found">No patient found</p>
            )}
          </tbody>
          {isLoading && <p className="no-patient-found">Searching...</p>}
        </table>


      </div>
    </div>
  );
};

export default PatientSearch;
